import { isPresent } from "@suse-o11y/is-present";
import { catchError, concat, from, map, of, switchMap } from "@suse-o11y/rxjs";
import type { AnyAction } from "redux";
import type { Epic } from "redux-observable";

import { Type, type UserScript } from "~/models/dto";

import { handleHTTPError } from "../../../common/errors";
import { typedStream } from "../../../generic/redux/TypedRedux";
import { type HTTPError, request } from "../../../generic/request";
import type { RootState } from "../RootState";

import {
	type ExecuteQuery,
	type QueryChanged,
	type QueryError,
	type QueryResultChanged,
	queryError,
	queryResultChanged,
} from "./AnalyticsActions";
import { EXECUTE_QUERY } from "./AnalyticsActionTypes";
import type { ResultType } from "./AnalyticsQuery";
import { selectConfig, selectCurrentQuery } from "./AnalyticsSelectors";

function detectResultType(result: unknown): ResultType {
	return isPresent(result) ? "json" : "text";
}

type Response = QueryChanged | QueryResultChanged | QueryError;

export const ExecuteQueryEpic: Epic<AnyAction, Response, RootState> = (actions, states) =>
	actions.pipe(
		typedStream<ExecuteQuery>(EXECUTE_QUERY),
		switchMap(() => {
			const state = states.value;
			const query = selectCurrentQuery(state);
			const config = selectConfig(state);
			const body: UserScript = {
				_type: Type.GroovyScript,
				body: query.query,
			};
			return concat(
				from(
					request<{
						result: unknown;
					}>("/api/script", {
						method: "POST",
						query: {
							timeoutSeconds: config.timeout,
						},
						body,
					}),
				).pipe(
					map((data) => queryResultChanged(data.result, detectResultType(data.result))),
					catchError((errorResult: unknown) => of(queryError(handleHTTPError(errorResult as HTTPError)))),
				),
			);
		}),
	);
